import React from "react"
import { AppBar, Grid, Toolbar } from "@material-ui/core"

import HeaderLogo from "molecules/HeaderLogo"
import LanguageSwitch from "organisms/LanguageSwitch"

const Header = () => {
  return (
    <AppBar color="inherit" position="relative">
      <Toolbar>
        <Grid container justify="space-between" alignItems="center">
          <Grid item>
            <Grid container justify="flex-start" alignItems="center">
              <Grid item>
                <HeaderLogo />
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <LanguageSwitch />
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}

export default Header
